<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/c27/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            深入实施新时代人才强市战略，大力实施“蓉城英才计划”，全面提升人才自主培养质量，培育壮大本土高层次人才队伍，助力成都创建国家吸引和集聚人才平台、加快建设全国创新人才高地。
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact" style="margin-top: -1.6rem;">
                <img class="top" src="./../assets/imgs//xllh/rcgysq_sqdx.png" alt="" />
                <div class="content" style="font-weight: 500; font-size: 0.26rem;background-color: rgb(232,238,255);">
                    “蓉城英才计划”支持范围为在蓉企业、事业单位等用人主体工作5年以上的全职在岗人员。项目设置包括个人项目和团队项目两个类别。
                    <div
                        style="width: 100%;background-color: #fff;margin: auto;border-radius: 0.2rem;padding: 0.3rem;padding-top:0.5rem;box-sizing: border-box;margin-top: 0.5rem;position: relative;">
                        <div
                            style="position: absolute;top: -0.32rem;left: 50%;transform: translateX(-50%);width: 2.98rem;height: 0.67rem;background-color: #739BFE;color: #fff;border-radius: 1rem;line-height: 0.67rem;text-align:center;font-size: 0.32rem;">
                            一、个人项目
                        </div>
                        杰出科学家项目、创新领军人才项目、创业领军人才项目、军民融合领军人才项目、哲学社会科学与文化艺术领军人才项目、城市治理领军人才项目、教育领军人才项目、乡村振兴领军人才项目、创新青年人才项目、社科青年人才项目。
                        <p style="color: #FF0000;">
                            注:创新青年人才项目、社科青年人才项目入选人才年龄须在40周岁以下（特别优秀的可放宽到42周岁）。
                        </p>
                    </div>
                    <div
                        style="width: 100%;background-color: #fff;margin: auto;border-radius: 0.2rem;padding: 0.3rem;padding-top:0.5rem;box-sizing: border-box;margin-top: 0.5rem;position: relative;">
                        <div
                            style="position: absolute;top: -0.32rem;left: 50%;transform: translateX(-50%);width: 2.98rem;height: 0.67rem;background-color: #739BFE;color: #fff;border-radius: 1rem;line-height: 0.67rem;text-align:center;font-size: 0.32rem;">
                            二、创新创业
                        </div>
                        团队须至少包括1名带头人和4名成员（不含顾问)，核心成员（含带头人)中至少2人为国家高层次人才特殊支持计划、“天府青城计划”“蓉城英才计划”领军人才层次以上入选者。项目成员一般均应取得博士学位或高级技术职称。
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/c27/rcyc-zcnr.png" alt="" />
                <div class="content" style="font-weight:500;font-size: 0.26rem;">
                    对“蓉城英才计划”入选人员，授予“蓉城英才计划”特聘专家称号，发放“蓉城人才绿卡（市级卡)”。给予入选个人最高100万、团队最高300万元资助，以及职务职称、薪酬待遇、创新创业、人才安居、子女入园入学、医疗保险、培训休假等方面给予政策支持保障。
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/c27/rcyc-sqlc.png" alt="" />
                <div class="content" style="font-size: 0.3rem;">
                    详见当年申报通知。
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/c27/rcyc-aqsj.png" alt="" />
                <div class="content" style="font-size: 0.3rem;">
                    按照每年度通知时间确定。
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/xllh/rclu-zrdw.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61886095">028-61886095</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市委组织部
                    </div>
                </div>
            </div>
        </section>
        <call phone="028-61886095"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },
    components: {
        call,
    },


    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    min-height: 100vh;
    padding-bottom: 2rem;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {

            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    text-align: left;
                    margin-top: 0.16rem;
                    line-height: 0.44rem;

                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.23rem;
                    text-align: left;
                    position: relative;
                    overflow: hidden;
                    line-height: 0.44rem;

                    .label {
                        width: 2.17rem;
                        height: 0.6rem;
                        background: #739bfe;
                        position: absolute;
                        top: 0;
                        display: flex;
                        left: 0;
                        align-items: center;
                        padding-left: 0.11rem;
                        line-height: 0.44rem;

                        color: #fff;

                        .letter {
                            width: 0.36rem;
                            height: 0.36rem;
                            background-color: #ffffff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 0.25rem 0px 0px 0px;
                            color: #739bfe;
                            margin-right: 0.12rem;
                            transform: translateY(-0.02rem);
                        }
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                    line-height: 0.44rem;

                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.3rem;
                font-weight: bold;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.3rem;
                font-weight: bold;
                text-align: left;
                color: #4e4e4e;
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
